import { gql } from '@apollo/client';

const ProductInfo = gql`
  fragment ProductInfo on Product {
    id
    active
    adminLocationIds
    adminLocations {
      id
      name
    }
    allowAnnually
    allowMarkup
    allowMonthly
    arches
    bypassInitialPeriod
    createdAt
    defaultRetainer
    defaultSubscriptionRetainer
    description
    distributeInitialEvenly
    enableArches
    externalId
    featuredImage
    hubspotId
    initialUnits
    internalName
    isEot
    isPfg
    isRetainer
    medicalCode
    medicalDescription
    warrantyAllowed
    name
    planProductsAttributes {
      id
      assignedProductId
      overridePrice
      price
    }
    planSubscription {
      id
      name
    }
    planSubscriptionId
    price
    productCategories {
      id
      name
    }
    productCategoryIds
    productFeaturesAttributes {
      id
      text
    }
    productImages {
      id
      imageUrl
    }
    productRenewalInterval {
      id
      name
    }
    productRenewalIntervalId
    productType
    requiresScan
    sku
    storeIds
    stores {
      id
      name
    }
    target
    unitsPerInterval
    updatedAt
    wholesalePrice
  }
`;

export default ProductInfo;
